import { useI18n } from '../../i18n/useI18n';

type PlatformChatMessagesStatusProps = {
  kind: 'loading' | 'error';
};

export function PlatformChatMessagesStatus({
  kind,
}: PlatformChatMessagesStatusProps) {
  const { translate } = useI18n();

  if (kind === 'loading') {
    return (
      <p className="platform-chat-page__messages-status">
        {translate('platformChat.messagesLoading')}
      </p>
    );
  }

  return (
    <p className="platform-chat-page__messages-status" role="alert">
      {translate('platformChat.messagesLoadError')}
    </p>
  );
}
